import React from 'react'

import * as S from '../styles'

interface ListFieldProps {
  label: string
  items: string[]
  otherText?: string | null
}

const EMPTY_PLACEHOLDER = '-'

const hasMeaningfulText = (value?: string | null): boolean => {
  return Boolean(value && value.trim() !== '')
}

export function ListField({ label, items, otherText }: ListFieldProps): JSX.Element {
  const safeItems = Array.isArray(items) ? items.filter(hasMeaningfulText) : []
  const showOther = hasMeaningfulText(otherText)
  const hasContent = safeItems.length > 0 || showOther

  return (
    <S.FieldWrapper>
      <S.FieldLabel>{label}</S.FieldLabel>
      {!hasContent && <S.FieldValue>{EMPTY_PLACEHOLDER}</S.FieldValue>}
      {safeItems.map((item, idx) => (
        <S.FieldValue key={`${item}-${idx}`}>{item}</S.FieldValue>
      ))}
      {showOther && <S.FieldValue>Outros: {otherText}</S.FieldValue>}
    </S.FieldWrapper>
  )
}
